// Module
var code = `<sub-header header="'Branches'" tab="true">
  <button class="btn btn-primary"
            type="button"
            command-access="CreateBranch"
            ng-click="\$ctrl.addNew()">
      Add new
    </button>
  </sub-header>

  <table class="administration-branches branches-list table"
         at-table
         at-list="\$ctrl.branches">
    <thead></thead>
    <tbody class="tbody">
    <tr>
      <td class="branches-list__number-column" at-title="No">
        {{\$index+1+'.'}}
      </td>
      <td at-implicit at-attribute="organization.name" at-title="Organization"></td>
      <td at-implicit at-attribute="name" at-title="Branch name"></td>
      <td at-implicit at-attribute="systemDate" at-title="System date"></td>
      <td at-implicit at-attribute="postingDate" at-title="Posting date"></td>
      <td at-implicit at-attribute="checkCutoffTime" at-title="Check cutoff time"></td>
      <td at-implicit at-attribute="clearingDay" at-title="Clearing day"></td>
      <td at-implicit at-attribute="status.label" at-title="Status"
          ng-class="{'active' : item.status.code === 'STARTED','pending' : item.status.code !== 'STARTED'}"></td>
      <td class=" branches-list__open-link-column" at-title="Actions">
        <div class="summary-actions">
          <button class="btn btn-warning open-link"
                  command-access="UpdateBranch"
                  type="button"
                  ng-click="\$ctrl.edit(item.id)">
            Edit
          </button>
          <button class="btn btn-danger open-link"
                  command-access="DeleteBranch"
                  type="button"
                  ng-click="\$ctrl.delete(item.id)">
            Delete
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/administration-branches/administration-branches.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;